import { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useMaterialUIController } from "context";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "axios";
import { useForm } from "react-hook-form";
import configurations from "config";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {
    LoginSocialGoogle,
    LoginSocialFacebook,
    IResolveParams,
} from 'reactjs-social-login';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Button } from "@mui/material";
import 'assets/css/common.css';
import { useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import { handleErrors } from 'common.js'

function Login() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [controller, dispatch] = useMaterialUIController();
    const { MyContext } = controller;
    const [isLoading, setIsLoading] = useState(false);
    const [provider, setProvider] = useState('');
    const [profile, setProfile] = useState('');
    const [acceptTokenPopup, setAcceptTokenPopup] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    var baseUrl = configurations.baseUrl;

    const TokenPopup = ({ open, onClose }) => {
        return (
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>{t('termsAndConditions')}</DialogTitle>
                <DialogContent>
                    <MDBox display="flex" alignItems="center" ml={-1}>
                        <MDInput
                            type="checkbox"
                            name="acceptTerms"
                            variant="standard"
                            checked={isChecked}
                            onChange={(event) => setIsChecked(event.target.checked)}
                        />
                        <MDTypography
                            variant="button"
                            fontWeight="regular"
                            color="text"
                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                        >
                            &nbsp;&nbsp;{t('iAgree')}&nbsp;
                        </MDTypography>
                        <MDTypography
                            component={Link}
                            to="/vendor/acceptTermsAndConditions"
                            variant="button"
                            fontWeight="bold"
                            color="info"
                            textGradient
                            target="_blank"
                        >
                            {t('termsAndConditions')}
                        </MDTypography>
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">{t('close')}</Button>
                </DialogActions>
            </Dialog>
        );
    }

    const { register, handleSubmit, formState: { errors }, setError } = useForm();

    const onSubmit = async (data) => {
        setIsLoading(true);
        await axios.post(baseUrl + '/vendor/login', data,
            {
                headers: { function: azureFunctionVendorFrontendKey }
            }).then((response) => {
                setIsLoading(false);

                const requestStatus = response.status;
                if (requestStatus == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        const token = response.data.data.token; // Assuming the token is returned as "token" property in the response
                        const userID = response.data.data.id;
                        const profileCompleteStatus = response.data.data.profileCompleteStatus; //1 for profilecompleted 
                        const resetPassword = response.data.data.resetPassword;
                        const name = response.data.data.name;

                        localStorage.setItem('JWTToken', token)
                        localStorage.setItem("userID", userID)
                        localStorage.setItem("profileCompleteStatus", profileCompleteStatus)
                        localStorage.setItem('resetPassword', resetPassword)
                        localStorage.setItem('name', name)
                        window.location.href = '/dashboard'; //window.location is used instead of navigate() as vendor name need to be set based on logged in user
                    }
                    else {
                        if (message != '')
                            toast.error(t(message));
                        if (response && response.data && response.data.errors) {
                            const errorData = response.data.errors;
                            errorData.forEach((error) => {
                                setError(error.field, {
                                    type: 'server',
                                    message: t(error.errors[0])
                                });
                            });
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            });
    };

    const onSocialMediaSubmit = async (data) => {
        isChecked ? handleClose() : null;
        let dataParams = {};
        if (provider == 'facebook') {
            baseUrl = baseUrl + '/vendor/fbLogin/';
            dataParams = { fbAccessToken: profile.accessToken, name: profile.name, fbId: profile.userID, acceptTerms: isChecked };
        }
        else {
            baseUrl = baseUrl + '/vendor/googleLogin/';
            dataParams = { googleAccessToken: profile.access_token, email: profile.email, name: profile.name, sub: profile.sub, acceptTerms: isChecked };
        }
        setIsLoading(true);
        await axios.post(baseUrl, dataParams,
            {
                headers: { function: azureFunctionVendorFrontendKey, provider: provider }
            }).then((response) => {
                setIsLoading(false);
                const requestStatus = response.status;
                if (requestStatus == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    const acceptTerms = response.data.data.acceptTerms;
                    if (status == 1) {
                        const token = response.data.data.token; // Assuming the token is returned as "token" property in the response
                        const userID = response.data.data.id;
                        const profileCompleteStatus = response.data.data.profileCompleteStatus; //1 for profilecompleted 
                        const name = response.data.data.name;

                        localStorage.setItem('JWTToken', token)
                        localStorage.setItem("userID", userID)
                        localStorage.setItem("profileCompleteStatus", profileCompleteStatus)
                        localStorage.setItem('name', name)
                        window.location.href = '/dashboard'; //window.location is used instead of navigate() as vendor name need to be set based on logged in user
                    }
                    else {
                        if (acceptTerms == 0)
                            setAcceptTokenPopup(true);
                        else {
                            if (message != '')
                                toast.error(t(message));

                            if (response && response.data && response.data.errors) {
                                const errorData = response.data.errors;
                                errorData.forEach((error) => {
                                    setError(error.field, {
                                        type: 'server',
                                        message: t(error.errors[0])
                                    });
                                });
                            }
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'));
                }
            }).catch(error => {
                setIsLoading(false);
                handleErrors(error, t, navigate);
            })
    }

    const onLoginStart = useCallback(() => {
    }, []);

    const onLogoutSuccess = useCallback(() => {
        setProfile(null);
        setProvider('');
    }, []);

    useEffect(() => {
        Object.keys(profile).length > 0 ?
            onSocialMediaSubmit()
            : null
    }, [profile, isChecked])

    const handleClose = () => {
        setAcceptTokenPopup(false);
    };

    return (
        <BasicLayout image={bgImage}>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
            <Card>
                <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center" >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>{t('signIn')}</MDTypography>
                    <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                        {MyContext.fbAppId != '' ?
                            <Grid item xs={2}>
                                <LoginSocialFacebook
                                    appId={MyContext.fbAppId}
                                    fieldsProfile={
                                        'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                                    }
                                    onLoginStart={onLoginStart}
                                    onLogoutSuccess={onLogoutSuccess}
                                    onResolve={({ provider, data }: IResolveParams) => {
                                        setProvider(provider);
                                        setProfile(data);
                                    }}
                                    onReject={err => {
                                    }}
                                >
                                    <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                                        <FacebookIcon />
                                    </MDTypography>
                                </LoginSocialFacebook>
                            </Grid>
                            :
                            null}

                        {MyContext.googleAppId != '' ?
                            <Grid item xs={2}>
                                <LoginSocialGoogle
                                    client_id={MyContext.googleAppId}
                                    onLoginStart={onLoginStart}
                                    scope='https://www.googleapis.com/auth/userinfo.email'
                                    onResolve={({ provider, data }: IResolveParams) => {
                                        setProvider(provider);
                                        setProfile(data);
                                    }}
                                    onReject={(err) => {
                                    }}
                                >
                                    <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                                        <GoogleIcon color="inherit" />
                                    </MDTypography>
                                </LoginSocialGoogle>
                            </Grid>
                            : null}
                    </Grid>
                    {acceptTokenPopup ?
                        <TokenPopup open={acceptTokenPopup} onClose={handleClose} />
                        : null
                    }

                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                label={t('email')}
                                name="email"
                                {...register("email", {
                                    required: {
                                        value: true,
                                        message: t('emailRequired')
                                    },
                                    pattern: {
                                        value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                        message: t('invalidEmail')
                                    }
                                })}
                                onChange={((e) => { e.stopPropagation() })}
                                fullWidth />
                            {errors.email && (<p className="errorMsg">{errors.email.message}</p>)}
                        </MDBox>
                        <MDBox mb={2}>
                            <MDInput
                                type="password"
                                label={t('password')}
                                name="password"
                                {...register("password", {
                                    required: {
                                        value: true,
                                        message: t('passwordRequired')
                                    },
                                    minLength: {
                                        value: MyContext.minPasswordLength,
                                        message: t('passwordMinLength', { minPasswordLength: MyContext.minPasswordLength })
                                    }
                                })}
                                onChange={((e) => { e.stopPropagation() })}
                                fullWidth />
                            {errors.password && (<p className="errorMsg">{errors.password.message}</p>)}
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton type="submit" variant="gradient" color="info" disableRipple fullWidth>{t('signIn')}</MDButton>
                        </MDBox>
                        <MDBox mt={3} mb={1} textAlign="center">
                            <MDTypography variant="button" color="text">
                                {t('dontHaveAccount')}
                                <MDTypography component={Link} to="/vendor/register" variant="button" color="info" fontWeight="medium" textGradient>{t('signUp')}</MDTypography>
                            </MDTypography>
                        </MDBox>
                        <MDBox mt={3} mb={1} textAlign="center">
                            <MDTypography component={Link} to="/vendor/forgotPassword" variant="button" color="info" fontWeight="medium" textGradient>{t('forgotPassword')}</MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default Login;
